export async function loadExcelExportModules() {
  const [excelModule, fileSaverModule] = await Promise.all([
    import('xlsx'),
    import('file-saver'),
  ]);
  const { utils, write } = excelModule;
  const saveAs = fileSaverModule.default;

  return { utils, write, saveAs };
}

export async function loadStyledExcelExportModules() {
  const [excelModule, fileSaverModule] = await Promise.all([
    import('xlsx-js-style'),
    import('file-saver'),
  ]);
  const { utils, write } = excelModule.default;
  const saveAs = fileSaverModule.default;

  return { utils, write, saveAs };
}
